import type { SelectedReceiver } from '../../components/transaction/SelectedReceiver';

export const canReceiverMakeImmediatePayment = (receiver: SelectedReceiver, blockedList: string) => {
    const blockedBanks = blockedList.split(',').filter((e) => e !== '');
    return !blockedBanks.some((b) => receiver.accountNumber.value.startsWith(b));
};
